const TENANT_STORAGE_KEY = "TENANT_ID";

export const getStoredTenantId = () => {
  if (typeof localStorage === "undefined") return "";
  return localStorage.getItem(TENANT_STORAGE_KEY) || "";
};

export const setStoredTenantId = (tenantId) => {
  if (!tenantId || typeof localStorage === "undefined") return;
  localStorage.setItem(TENANT_STORAGE_KEY, String(tenantId));
  if (typeof window !== "undefined") {
    window.__TENANT_ID__ = String(tenantId);
  }
};

export const getTenantHeaderValue = () => {
  const tenantId = getStoredTenantId();
  if (tenantId) return tenantId;
  if (typeof window !== "undefined" && window.location) {
    return window.location.hostname;
  }
  return "";
};

export const getTenantAssetBaseUrl = (baseUrl = process.env.VUE_APP_BASE_URL || "") => {
  if (!baseUrl) return "";
  return `${baseUrl.replace(/\/+$/, "")}/`;
};

export const resolveTenantAssetUrl = (
  assetPath = "",
  baseUrl = process.env.VUE_APP_BASE_URL || ""
) => {
  if (!assetPath) return "";
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  const normalizedBase = String(baseUrl || "").replace(/\/+$/, "");
  const normalizedPath = String(assetPath).replace(/^\/+/, "");
  if (!normalizedBase) return normalizedPath;
  return `${normalizedBase}/${normalizedPath}`;
};
